import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getInvoiceDetails } from "src/api/invoice";
import CustomDataTable from "../CustomDataTable";
import { getCustomizationValue, renderCurrency } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";

const columns = [
	{
		name: "Item",
		selector: (row) => row.product.name,
	},
	{
		name: "Qty",
		selector: (row) => row.qty,
		width: "90px",
	},
	{
		name: "Unit Price",
		selector: (row) => renderCurrency(row.product_price),
	},
	{
		name: "Total",
		selector: (row) => renderCurrency(row.amount),
	},
];

const PaymentDetailModal = ({ paymentId }) => {
	const { user } = useAuth();

	const { data } = useQuery({
		queryKey: ["payments", paymentId],
		queryFn: () => getInvoiceDetails(paymentId),
		suspense: true,
	});

	const invoice = data?.data;

	return (
		<div>
			<div className="modal_cont_sect">
				<h4>Contact Details</h4>

				<div className="cont_sect_itm">
					<p>{getCustomizationValue(user, "customer_label", true)} Name:</p>
					<p>
						{invoice?.customer.first_name} {invoice?.customer.last_name}
					</p>
				</div>

				<div className="cont_sect_itm">
					<p>{getCustomizationValue(user, "customer_label", true)} Email:</p>
					<p>{invoice?.customer.email}</p>
				</div>

				<div className="cont_sect_itm">
					<p>{getCustomizationValue(user, "customer_label", true)} Phone:</p>
					<p>{invoice?.customer.phone}</p>
				</div>
			</div>

			<div className="modal_cont_sect">
				<CustomDataTable
					columns={columns}
					data={invoice?.items ?? []}
					containerClassName="tw-shadow-none"
					customStyles={{
						headCells: {
							style: {
								paddingBlock: "25px 10px",
								paddingInline: "5px",
							},
						},
						cells: {
							style: {
								paddingInline: "5px",
							},
						},
					}}
				/>

				<div className="inv_totals">
					<div className="inv_total_itm">
						<p>Sub Total</p>
						<p>{renderCurrency(invoice?.amount)}</p>
					</div>

					<div className="inv_total_itm">
						<p>Discount</p>
						<p>{renderCurrency(invoice?.discount_amount)}</p>
					</div>

					<div className="inv_total_itm">
						<p>VAT</p>
						<p>{renderCurrency(invoice?.vat)}</p>
					</div>

					<div className="inv_total_itm">
						<p>{getCustomizationValue(user, "invoice_label", true)} Total</p>
						<p>{renderCurrency(invoice?.total_amount)}</p>
					</div>

					<div className="inv_total_itm">
						<p>Transaction fee</p>
						<p>{renderCurrency(invoice?.transaction_fee)}</p>
					</div>

					<div className="inv_total_itm bold_txt">
						<p>Transaction Amount</p>
						<p>{renderCurrency(invoice?.transaction_amount)}</p>
					</div>
				</div>
			</div>

			<div className="modal_cont_sect">
				<div className="cont_sect_itm">
					<p>Mode of Payment:</p>
					<p>Transfer</p>
				</div>
			</div>

			<div className="mt-1 modal_footer">
				<button className="tw-w-full green-btn">Download Receipt as PDF</button>
			</div>
		</div>
	);
};

export default PaymentDetailModal;
